import React from 'react'
import "./JoinUs.css"
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import JoinUsComponents from "./JoinUsComponents/JoinUsComponents";

const JoinUs = () => {
  return (
    <div className="JoinUs">
      <NavBar />
      <JoinUsComponents />
      <Footer />
    </div>
  );
};

export default JoinUs;
